// =============================================================================
// src/data/sentinel-live-config.ts — Configuração da integração Sentinel (Hasura).
// =============================================================================

export interface SentinelLiveEnv {
  readonly VITE_HASURA_URL?: string;
  readonly VITE_SENTINEL_CLIENT_ID?: string;
  readonly VITE_ATALAIA_API_URL?: string;
  readonly VITE_COPILOT_LLM_ENABLED?: string;
}

export interface SentinelLiveConfig {
  readonly enabled: boolean;
  readonly graphqlEndpoint: string;
  readonly clientId: string;
  readonly apiEndpoint: string;
  readonly copilotLlmEnabled: boolean;
}

const DEFAULT_CLIENT_ID = 'a0000000-0000-4000-8000-000000000001';

export function resolveSentinelLiveConfig(env: SentinelLiveEnv): SentinelLiveConfig {
  const graphqlEndpoint = (env.VITE_HASURA_URL ?? '').trim();
  const clientId = (env.VITE_SENTINEL_CLIENT_ID ?? DEFAULT_CLIENT_ID).trim();
  const apiEndpoint = (env.VITE_ATALAIA_API_URL ?? 'http://localhost:8000').trim();
  const copilotFlag = (env.VITE_COPILOT_LLM_ENABLED ?? 'true').trim().toLowerCase();
  return {
    enabled: graphqlEndpoint.length > 0,
    graphqlEndpoint,
    clientId,
    apiEndpoint,
    copilotLlmEnabled: copilotFlag !== 'false' && copilotFlag !== '0',
  };
}
